var map = {
	"./Household.jpg": 213
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;


//////////////////
// WEBPACK FOOTER
// ./src/images/householdProducts nonrecursive \.(png|jpe?g|svg)$
// module id = 212
// module chunks = 0